
export const Main = "#00cccc";
export const Sub = "#1c2126";
export const Content = "white";
export const LLight = "#d9d9d9";
export const Light = "#a6a6a6";
export const Dark = "#595959";
export const Background = "#00010d";